import { render, staticRenderFns } from "./PresentationComment.vue?vue&type=template&id=804eb3c0&scoped=true&"
import script from "./PresentationComment.vue?vue&type=script&lang=ts&"
export * from "./PresentationComment.vue?vue&type=script&lang=ts&"
import style0 from "./PresentationComment.vue?vue&type=style&index=0&id=804eb3c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804eb3c0",
  null
  
)

export default component.exports